import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import Premium from "../../../pages/Premium/Premium";
import { useUser } from "../../../../providers/user.provider";
import { ERolesEnum } from "../../../../enums/roles.enum";

const PaymentDialog = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const { user, refreshUser } = useUser();

  // Roles that can bypass the forced payment popup
  const privilegedRoles = [
    ERolesEnum.admin,
    ERolesEnum.superadmin,
    ERolesEnum.manager,
    ERolesEnum.moderator,
  ];

  // Check if user has an active paid subscription
  const accessedAt = user?.accessed_at ? new Date(user.accessed_at) : null;
  const isSubscriptionActive = accessedAt != null && accessedAt >= new Date();

  const hasPaidSubscription =
    (user?.access != null && user.access !== "regular") ||
    user?.typeSubscription != null ||
    isSubscriptionActive ||
    (user as any)?.activeSubscription != null;

  // Privileged roles can always close
  const canClose =
    privilegedRoles.includes(user?.role as ERolesEnum) ||
    (user?.accessRoles?.some((r) =>
      privilegedRoles.includes(r.title as ERolesEnum)
    ) ?? false) ||
    hasPaidSubscription;

  // Show dialog only for unpaid regular users on every page navigation/reload
  useEffect(() => {
    if (!user?.id || location.pathname.includes("/auth/")) {
      // User not logged in yet or on auth pages — keep dialog closed
      setOpen(false);
      return;
    }

    if (canClose) {
      // Privileged role or paid user — never show dialog
      localStorage.removeItem("payment");
      setOpen(false);
    } else {
      // Unpaid regular user — always show dialog
      setOpen(true);
    }
  }, [location.pathname, user?.id, canClose]);

  // When dialog is open and user returns from Stripe tab — refresh user data
  useEffect(() => {
    if (!open) return;

    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        refreshUser();
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => document.removeEventListener("visibilitychange", handleVisibilityChange);
  }, [open, refreshUser]);

  const handleClose = () => {
    localStorage.removeItem("payment");
    setOpen(false);
  };

  return (
    <Dialog
      onClose={canClose ? handleClose : () => {}}
      disableEscapeKeyDown={!canClose}
      aria-labelledby="customized-dialog-title"
      open={open}
      className="popup"
      PaperProps={{
        style: {
          maxWidth: "1200px",
        },
      }}
    >
      <Premium dialog={open} close={handleClose} />
    </Dialog>
  );
};

export default PaymentDialog;
